__webpack_require__.p = "/public/site/sportsolutions/dist/";